import { InputDescription, InputTitle } from 'components/atoms/styleds';
import RadioButtons from 'components/atoms/RadioButtons';
import {
  ZoneMunicipality,
  ZoneRadius,
} from 'components/molecules/settings/relation-views';

import { ConfigBlock } from '../../styled';
import BaseErrors from '../../../../atoms/BaseError';

const AreasContent = ({
  data,
  onChange,
  handleChangeDeliveryZips,
  deliveryZips,
  onClickCreateDelivery,
  onDeleteDelivery,
  errors,
}) => {
  const items = [
    {
      id: 'a1',
      label: 'Comune/i',
      value: 'place',
    },
    {
      id: 'a2',
      label: 'Raggio',
      value: 'radius',
    },
  ];

  const showRadius = data.delivery_zone === 'radius';
  const showMunicipal = data.delivery_zone === 'place';

  const hideSecondZone = data?.delivery_cost_type === 'fixed' || data?.delivery_cost_type === 'per_kilometer';

  return (
    <ConfigBlock>
      <InputTitle>Zone servite</InputTitle>
      <InputDescription>
        Seleziona l’area in cui effettuerai il servizio di delivery.
      </InputDescription>
      <RadioButtons
        onChange={onChange}
        name='delivery_zone'
        selected={data.delivery_zone}
        items={items}
      />
      {showMunicipal && (
        <ZoneMunicipality
          data={data}
          onChange={handleChangeDeliveryZips}
          onClickCreate={onClickCreateDelivery}
          onDelete={onDeleteDelivery}
          items={deliveryZips}
          errors={errors}
          hideSecondZone={hideSecondZone}
        />
      )}
      {showRadius && <ZoneRadius onChange={onChange} data={data} />}
      <BaseErrors errors={errors} />
    </ConfigBlock>
  );
};

export default AreasContent;
